// extracted by mini-css-extract-plugin
export default {"mask":"DownloadCancel_mask__kv9GG","containerStyle":"DownloadCancel_containerStyle__6tnpn"};